import { FULL_NAME, SHORT_NAME } from './nameTypes';
import format from 'date-fns/format';

export const storybookDefaultValues: Record<string, unknown> = {
  'data-date': {
    date: format(new Date(), 'yyyy-MM-dd'),
    dateFormat: 'YYYY-MM-DD',
  },
  'data-team-name-type': FULL_NAME,
  'data-refresh-time': 'never',
  'data-entity-links': {},
  'data-short-status-type': SHORT_NAME,
  'data-theme': 'light',
  'data-popular-list': 'default',
  'data-labels': {},
  'data-header-display': true,
  'data-header-default-option': null,
  'data-odds-betting-id': null,
  'data-odds-display': true,
  'data-odds-market': null,
  'data-odds-pre-event-only': null,
  'data-odds-market-value-type': 'decimal',
  'data-stage': null,
  'data-season': null,
  'data-competition': null,
  'data-player': null,
  'data-team': null,
  'data-match-id': null,
  'data-tabs-info-labels': null,
  'data-tabs': null,
  'data-display-tabs': null,
  'data-default-tab': null,
  'data-rounds': null,
  'data-match-type': null,
  'data-sort-direction': 'desc',
  'data-groups': null,
  'data-amount': 10,
};
